import { httpClient } from "@sia/style-guide";
import MasterKeyValidationAdapter from "./MasterKeyValidationAdapter";

const masterKeyValidationAdapter = new MasterKeyValidationAdapter(httpClient);
export default masterKeyValidationAdapter;
